/**
 * LD.CLPBP.Public.Service
 * No descripton provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use strict';
import * as models from './models';

export interface LDCLPBPPublicApiModelsLoanApplicationsPersonalGetPersonalLoanApplicationResponse {
    

    guid?: string;

    leadGuid?: string;

    loanType?: LDCLPBPPublicApiModelsLoanApplicationsPersonalGetPersonalLoanApplicationResponse.LoanTypeEnum;

    loanPurpose?: LDCLPBPPublicApiModelsLoanApplicationsPersonalGetPersonalLoanApplicationResponse.LoanPurposeEnum;

    projectType?: LDCLPBPPublicApiModelsLoanApplicationsPersonalGetPersonalLoanApplicationResponse.ProjectTypeEnum;

    loanApplicationState?: LDCLPBPPublicApiModelsLoanApplicationsPersonalGetPersonalLoanApplicationResponse.LoanApplicationStateEnum;

    requestedLoanAmount?: number;

    loanNumber?: number;

    borrowers?: Array<models.LDCLPBPPublicApiModelsBorrowersGetBorrowerResponse>;

    term?: string;

    promoCode?: string;
}
export namespace LDCLPBPPublicApiModelsLoanApplicationsPersonalGetPersonalLoanApplicationResponse {

    export enum LoanTypeEnum { 
        Undefined = <any> 'Undefined',
        Personal = <any> 'Personal',
        HomeImprovement = <any> 'HomeImprovement',
    }

    export enum LoanPurposeEnum { 
        CreditCardRefinancing = <any> 'CreditCardRefinancing',
        DebtConsolidation = <any> 'DebtConsolidation',
        HomeImprovement = <any> 'HomeImprovement',
        MajorPurchase = <any> 'MajorPurchase',
        HomePurchase = <any> 'HomePurchase',
        CarFinancing = <any> 'CarFinancing',
        GreenLoan = <any> 'GreenLoan',
        Business = <any> 'Business',
        Vacation = <any> 'Vacation',
        MovingAndRelocation = <any> 'MovingAndRelocation',
        MedicalExpenses = <any> 'MedicalExpenses',
        Other = <any> 'Other',
    }

    export enum ProjectTypeEnum { 
        ConcreteBrickAndStone = <any> 'ConcreteBrickAndStone',
        DeckingShadeStructures = <any> 'DeckingShadeStructures',
        Electrical = <any> 'Electrical',
        FlooringAndHardwood = <any> 'FlooringAndHardwood',
        GeneralContractor = <any> 'GeneralContractor',
        Generators = <any> 'Generators',
        HeatingAndAC = <any> 'HeatingAndAC',
        HurricaneStructures = <any> 'HurricaneStructures',
        Insulation = <any> 'Insulation',
        Landscaping = <any> 'Landscaping',
        Lighting = <any> 'Lighting',
        PaintingAndStaining = <any> 'PaintingAndStaining',
        PlumbingAndHeating = <any> 'PlumbingAndHeating',
        Remodeling = <any> 'Remodeling',
        Roofing = <any> 'Roofing',
        Seawalls = <any> 'Seawalls',
        Seismic = <any> 'Seismic',
        Solar = <any> 'Solar',
        SwimmingPoolsAndSpas = <any> 'SwimmingPoolsAndSpas',
        WaterSaving = <any> 'WaterSaving',
        WindowsAndDoors = <any> 'WindowsAndDoors',
    }

    export enum LoanApplicationStateEnum { 
        Start = <any> 'Start',
        Registering = <any> 'Registering',
        LeadQuoting = <any> 'LeadQuoting',
        Quoting = <any> 'Quoting',
        Applying = <any> 'Applying',
        Reviewing = <any> 'Reviewing',
        ReviewSuspended = <any> 'ReviewSuspended',
        FraudAnalyzing = <any> 'FraudAnalyzing',
        Declined = <any> 'Declined',
        Accepting = <any> 'Accepting',
        AcceptingCounter = <any> 'AcceptingCounter',
        Expired = <any> 'Expired',
        Finalizing = <any> 'Finalizing',
        Withdrawn = <any> 'Withdrawn',
        Funding = <any> 'Funding',
        Funded = <any> 'Funded',
        PaidOff = <any> 'PaidOff',
    }
}
